import { IGetByIdSatisfacaoClienteUseCase } from "../../../presentation/useCases/read/get_by_id_satisfacao_cliente_use_case";
import { SatisfacaoClienteDetalhe } from "../../models/satisfacao_cliente_detalhe";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetByIdSatisfacaoClienteUseCase
 */

export class GetByIdSatisfacaoClienteUseCase implements IGetByIdSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async getByIdSatisfacaoCliente(
    idSatisfacaoCliente: number | undefined,
  ): Promise<SatisfacaoClienteDetalhe> {
    if (idSatisfacaoCliente === undefined) throw new Error('Falha ao obter id de satisfacao cliente.');
    const response = await this.repository.getByIdSatisfacaoCliente(idSatisfacaoCliente);
    if (response === null) throw new Error('Satisfação do cliente não encontrada.');
    return response;
  }
}
